import { APP_BACK_HIDE,
         APP_BACK_SHOW,
         APP_DONE,
         APP_RESET,
         APP_SET_BACK_PAGE,
         APP_SET_CONFIG,
         APP_SET_LANGUAGE,
         APP_SET_PLATE,
         APP_SET_ROUTE, 
         APP_SET_ROUTE_DONE,
         APP_SET_TAB,
         APP_WAIT
    } from "../../constants/action-types";

import initialState from "../initialState";

const app = (state = initialState.app, action) => {    
    switch (action.type) {
        case APP_BACK_HIDE:
            return { ...state, back: false }

        case APP_BACK_SHOW:
            return { ...state, back: true }

        case APP_DONE:
            return { ...state, appState: 0 }

        case APP_RESET:
            return { ...state,
                appState: 0,
                delivState: 0,
                dialogOpen: false,
                dialogState: 0,
                ordersState: 0,
                sensorsState: 0
            };

        case APP_SET_BACK_PAGE:
            return { ...state, backPage: action.payload }

        case APP_SET_CONFIG:
            return { ...state, config: action.payload }

        case APP_SET_LANGUAGE:
            return {
                ...state,
                language: action.payload
            };

        case APP_SET_PLATE:
            return { ...state, plate: action.payload }

        case APP_SET_ROUTE:
            return {
                ...state,
                appState: 3,
                route: action.payload
            }

        case APP_SET_TAB:
            return { ...state, activeTab: action.payload }

        case APP_SET_ROUTE_DONE:
            return {
                ...state,
                appState: 0
            }

        case APP_WAIT:
            return { ...state, appState:2 }
                
        default:
            return state;
    }
}

export default app;


// WEBPACK FOOTER //
// ./src/store/reducers/app.js